import { DownloadApps } from 'src/components/DownloadApps';
import { URLS } from 'src/utils/urls/urls';

export const WinbackOfferDownloadAppsPage = () => (
  <DownloadApps to={URLS.STORE_METHODS_OFFER_SETUP_COMPLETE} />
);
